import React from 'react';
import { connect } from 'react-redux';
import { Dialog, withStyles } from '@material-ui/core';
import * as Yup from 'yup';

import PrintLabelForm from './PrintLabelForm';
import { hasPermission } from '../../sc-utilities';
import * as pcProductActions from '../PCProduct/store/pcProductActions';
import { snackActions } from '../../sc-utilities/SnackBar';
import * as storageProductActions from '../StorageProduct/store/storageProductActions';
import * as mobileProductActions from '../MobileProduct/store/mobileProductActions';
import * as displayProductActions from '../DisplayProduct/store/displayProductActions';

const styles = (theme) => ({
  root: {
    width: 'auto',
    height: 'auto',
    padding: theme.spacing(2),
    paddingRight: theme.spacing(6),
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
      paddingRight: 0,
    },
  },
  submit: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    overflow: 'hidden',
    alignItems: 'center',
  },

  cancel: {
    width: '250px',
    margin: '10px',
  },
});

const PrintLabelFormSave = (props) => {
  const {
    productID,
    userSettings,
    textButton,
    loading,
    open,
    diagnoseSessionID,
    isPrinted,
    printers,
    activeCustomer,
    translations,
    permissions,
    onPrintLabel,
    handleOpen,
    type,
  } = props;

  const handleSubmit = async (data) => {
    if (type === 'diagnose') {
      data['DiagnoseSessionID'] = diagnoseSessionID;
    }
    data['ProductID'] = productID;
    let result = await onPrintLabel({
      ...data,
      ActiveCustomerID: activeCustomer,
      Type: type,
    });
    if (!result) {
      snackActions.snackBarComponent(
        translations['printed_message_fail'] ||
        'Something went wrong. Print request failed. Please contact administrator.',
        'warning'
      );
    } else {
      snackActions.snackBarComponent(
        translations['printed_message_success'] ||
        'Print request was successful.',
        'success'
      );
    }
    handleOpen();
  };

  const cancelHandler = () => {
    handleOpen();
  };

  let initialValues = {
    PrinterID: userSettings?.LastUsedPrinter || (printers.length > 0 ? printers[0].value : ''),
    OriginalLabel: false,
  };

  let formSettings = {
    Validation: {
      PrinterID: Yup.string().required('Required'),
      OriginalLabel: Yup.boolean(),
    },
    ButtonSubmit: hasPermission(permissions, 'product_print_label')
      ? {
        Title: textButton ? textButton : translations['save'] || 'SAVE',
        Color: 'primary',
      }
      : null,
    ButtonCancel: {
      Title: translations['cancel'] || 'CANCEL',
      handleCancel: cancelHandler,
    },
  };

  return (
    <Dialog
      open={open}
      disableBackdropClick={true}
      disableEscapeKeyDown={false}
      fullWidth={true}
      onClose={cancelHandler}
    >
      <PrintLabelForm
        formSettings={formSettings}
        initialValues={initialValues}
        handle={handleSubmit}
        loading={loading}
        isPrinted={isPrinted}
        printers={printers}
        translations={translations}
      />
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {
    activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    permissions: state?.core?.login?.permissions || [],
    translations:
      state.translate && state.translate.translations
        ? state.translate.translations.activeTranslations || {}
        : {},
    userSettings: state?.core?.login?.userSettings
  };
};
const checkProduct = (product, dispatch) => {
  switch (product.Type) {
    case 'mobileProduct':
      return dispatch(mobileProductActions.printLabel(product));
    case 'storageProduct':
      return dispatch(storageProductActions.printLabel(product));
    case 'pcProduct':
      return dispatch(pcProductActions.printLabel(product));
    case 'displayProduct':
      return dispatch(displayProductActions.printLabel(product));
    default:
      break;
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onPrintLabel: (product) => checkProduct(product, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(PrintLabelFormSave));
